import { render } from "./IdealCenters.vue?vue&type=template&id=2ea8cc66"
import script from "./IdealCenters.vue?vue&type=script&lang=js"
export * from "./IdealCenters.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__